<template>
  <div class="h-full relative">
    <div
      v-if="isVisible"
      class="absolute h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-40"
    >
      <div class="w-1/2 shadow-lg" :style="{ backgroundColor: bgColor }">
        <div class="flex justify-between px-12 mt-4">
          <RandomText class="text-6xl"></RandomText>
          <div
            @click="infoShow"
            class="flex justify-end cursor-pointer creu-in"
          >
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>

        <fidelio-process
          :process="process"
          :processInfo="processInfo"
        ></fidelio-process>
      </div>
      <div class="w-1/2 opacity-60" :style="{ backgroundColor: bgColor }">
        <div
          class="w-full h-full opacity-20"
          :style="{ backgroundColor: bgColor }"
        ></div>
      </div>
    </div>
    <div class="flex flex-col h-full justify-between">
      <div class="flex justify-between">
        <div class="flex z-50 items-end p-4">
          <RandomText class="text-3xl p-5">L'anomala</RandomText>
          <RandomText class="text-xl text-gray-400 pl-1">
            Developer - Interaction design
          </RandomText>
        </div>
      </div>
      <div>
        <RandomText class="cursor-pointer text-3xl p-5" @click="processShow"
          >Process</RandomText
        >
      </div>
    </div>

    <slider-projects :slides="slides" />
  </div>
</template>

<script>
import SliderProjects from "@/components/SliderProjects.vue";
import FidelioProcess from "@/components/FidelioProcess.vue";
import RandomText from "@/components/RandomText.vue";

export default {
  name: "App",
  components: {
    SliderProjects,
    FidelioProcess,
    RandomText,
  },
  props: {
    bgColor: {
      type: String,
      required: true,
      default: "rgb(255, 255, 255)",
    },
  },
  data() {
    return {
      isVisible: false,
      slides: [
        {
          type: "text",
          content:
            "El projecte transmèdia L’Anòmala neix de la col·laboració de set estudiants com a treball de fi de carrera. Es tracta d'una instal·lació interactiva que busca generar una experiència gastronòmica on els usuaris qüestionin la seva manera de menjar a través d'un àpat ple de provocacions. Ens hem encarregat de tot el procés, des de la concepció fins a l'execució de l'experiència. El meu paper en aquest projecte ha estat assumir la direcció i desenvolupar tota la infraestructura digital.",
        },
        {
          type: "image",
          content: "/img/anomala/anomala1.png",
        },
        {
          type: "image",
          content: "/img/anomala/anomala2.png",
        },
        {
          type: "image",
          content: "/img/anomala/anomala3.png",
        },
        {
          type: "image",
          content: "/img/anomala/anomala5.JPG",
        },
        {
          type: "image",
          content: "/img/anomala/anomala4.png",
        },
        {
          type: "image",
          content: "/img/anomala/anomala6.JPG",
        },
      ],
      process: [
        {
          text: "L'Anòmala és una experiència immersiva i interactiva, i hem buscat aconseguir aquests dos elements de maneres diverses. En primer lloc, per aconseguir la sensació d'immersió dins de l'espai, vam crear projeccions a les quatre parets i sobre la taula, acompanyades de so per crear l'ambient immersiu desitjat.",
        },
        {
          text: "Pel que fa a la interactivitat, hem seguit dues vies: la programació física i la digital. La meva responsabilitat ha estat desenvolupar tota la infraestructura digital. Per permetre als usuaris interactuar directament amb l'experiència, he incorporat diverses tecnologies NFC. D'altra banda, he utilitzat la visió per computadora i el tracking d'elements perquè l'usuari pugui interactuar directament amb les projeccions basant-se en els diferents elements presents a la taula. Cada element contenia un codi que, quan era llegit per una càmera, provocava canvis en les diferents projeccions.",
        },
        {
          text: "A més a més, vaig desenvolupar un codi específic que mostrava visualment, a través d'elements a la taula, quin dels comensals parlava més durant l'àpat. En temps real, des d'una sala de control, supervisava les interaccions i ajustava dinàmicament els elements gràfics segons l'activitat de conversa de cada participant. Aquesta funcionalitat afegida proporciona una dimensió interactiva única, permetent als usuaris prendre consciència de la dinàmica de la seva conversa i incentivant una participació equitativa i enriquidora.",
        },
      ],
      processInfo: [
        {
          title: "Equip:",
          subtitle: "Young Vic",
        },
        {
          title: "Location:",
          subtitle: "Young Vic, Maria studio",
        },
        {
          title: "Direction:",
          subtitle: "Natalie Abrahami",
        },
        {
          title: "Scenography and costumes:",
          subtitle: "Patrick Burnier",
        },
        {
          title: "Photography:",
          subtitle: "Richard H. Smith",
        },
      ],
    };
  },
  methods: {
    processShow() {
      this.isVisible = !this.isVisible;
    },
    infoShow() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style>
.creu-in {
  animation: fadeInOut 5s ease-in-out infinite;
}

@keyframes fadeInOut {
  0% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
  50% {
    transform: translateY(90vh) scale(0.2);
    opacity: 0%;
  }
  100% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
}
</style>

